import * as Icons from 'bricks-ui/packages/bricks-ui-icons';

export default Icons;
